import { Action } from 'redux';
import { actionTypes as t, UpdateProjectTimezoneAction } from '../actions';

export const projectTimeZoneReducer = (state: string = '', action: Action) => {
  switch (action.type) {
    case t.UPDATE_PROJECT_TIMEZONE: {
      const { payload } = action as UpdateProjectTimezoneAction;
      return payload.timeZone;
    }
    default:
      return state;
  }
};
